module.exports = __webpack_public_path__ + "img/weiyangchun.92ccb6b0.jpg";